// extracted by mini-css-extract-plugin
export default {"root":"wRywiQgG","item":"K1LCWOep"};